const wann1 = {
  title: "Anfang erster Weltkrieg",
  caption: "1. Weltkrieg",
  date: "28. Juli 1914",
  description:
    "Der Anfang des ersten Weltkrieges welcher Weltweit unzählige tote forderte.",
};
const wann2 = {
  title: "Ende zweiter Weltkrieg",
  caption: "2. Weltkrieg",
  date: "2. September 1945",
  description:
    "Das Ende des zweiten Weltkrieges welcher Weltweit unzählige tote forderte und bis heute der letzte Weltkrieg war.",
};
const wann3 = {
  title: "Caesars Ermordung",
  caption: "Caesars Ermordung",
  date: "15. März 44 v. Chr.",
  description: "Julius Caesar wurde von einer Gruppe von Senatoren erstochen.",
};
const wann4 = {
  title: "Berliner Mauerfall",
  caption: "Berliner Mauerfall",
  date: "9. November 1989",
  description:
    "Die Berliner Mauer fiel und vereinte wieder Ost mit West Deutschland.",
};
const wann5 = {
  title: 'Veröffentlichung Micheal Jacksons "Thriller"',
  caption: 'MJ "Thiller"',
  date: "30. November 1982",
  description:
    'Micheal Jacksons erfolgreichstes Album "Thriller". Es ist bis heute das meistverkaufte Album der Welt.',
};
const wann6 = {
  title: "Erfindung der ersten Glühbirne",
  caption: "Erfindung Glühbirne",
  date: "21. Oktober 1879",
  description:
    "Thomas Edison erfand die erste Glühbirne. Nach Tausenden von Versuchen entdeckte er endlich eine Möglichkeit, die funktionierte, und ihm ging dadurch ein Licht auf.",
};
const wann7 = {
  title: 'Martin Luther King Jrs "I have a Dream" Rede',
  caption: '"I have a Dream"',
  date: "28. August 1963",
  description:
    'Die Weltbekannte "I have a Dream" Rede von Martin Luther King Jr die heutzutage jeder Schüler lernt, in der Luther davon reden das er von einem Amerika träumt in dem farbige die gleichen Rechte haben wie weiße.',
};
const wann8 = {
  title: "Die Schlacht von Alesia",
  caption: "Schlacht Alesia",
  date: "2. Oktober 52 v. Chr.",
  description:
    "Die Schlacht der Römer gegen die Gallier die bekannt dafür ist, dass die Römer eine doppelten Schutzwall bauten zur Belagerung Alesias und um gleichzeit geschützt zu sein von Nachschubstruppen der Gallier.",
};
const wann9 = {
  title: "Die Schlacht von Waterloo",
  caption: "Schlacht Waterloo",
  date: "18. Juni 1815",
  description: "Die große und bekannte Niederlage Napoleons.",
};
const wann10 = {
  title: "Die Schlacht der 300 Spartaner gegen die Perser",
  caption: "Schlacht der 300 Spartaner",
  date: "9. August 480 v. Chr.",
  description:
    "Die Schlacht der 300 Spartaner die loszogen und sich auf dem Weg Versterkung holten um an den Thermopylen gegen die Perser zu kämpfen und den Griechen zeit zu verschaffen zur Verteidigung.",
};
const wann11 = {
  title: "Erster militärischer Einsatz einer Atombombe",
  caption: "Einsatz Atombombe",
  date: "6. August 1945",
  description: "Der erste militärische Einsatz der verherenden Atombombe.",
};
const wann12 = {
  title:
    "Erstmalige Vereidigung eines afroamerikanischen Präsidenten der Vereinigten Staaten",
  caption: "Erster schwarzer US-Präsident",
  date: "20. Januar 2009",
  description:
    "Barack Obama wurde als erster afroamerikanischer Präsident der USA vereidigt. Seine Wahl stellte einen historischen Wendepunkt dar. Sie hatte große symbolische Bedeutung für viele Menschen weltweit.",
};

const wann13 = {
  title: "Untergang des Passagierschiffs Titanic nach schwerem Schiffsunglück",
  caption: "Untergang der Titanic",
  date: "15. April 1912",
  description:
    "Die Titanic sank nach einer Kollision mit einem Eisberg im Nordatlantik. Dabei kamen über 1500 Menschen ums Leben. Das Unglück zählt zu den bekanntesten Schiffskatastrophen der Geschichte.",
};

const wann14 = {
  title: "Tödliches Attentat auf den amtierenden US-Präsidenten John F Kennedy",
  caption: "Kennedy-Attentat",
  date: "22. November 1963",
  description:
    "John F. Kennedy wurde während eines Besuchs in Dallas erschossen. Das Attentat schockierte die Bevölkerung zutiefst. Die Hintergründe sind bis heute Gegenstand von Diskussionen.",
};

const wann15 = {
  title: "Veröffentlichung geheimer Überwachungsprogramme durch Edward Snowden",
  caption: "Snowden-Enthüllungen",
  date: "5. Juni 2013",
  description:
    "Edward Snowden machte geheime Dokumente über weltweite Überwachung öffentlich. Die Enthüllungen lösten internationale Diskussionen aus. Themen wie Datenschutz und Privatsphäre rückten stark in den Fokus.",
};

const wann16 = {
  title: "Politischer Beginn des Kalten Krieges zwischen Ost und West",
  caption: "Beginn Kalter Krieg",
  date: "12. März 1947",
  description:
    "Die Vereinigten Staaten legten mit einer neuen außenpolitischen Strategie ihren Kurs fest. Daraus entwickelte sich eine langjährige politische und ideologische Konfrontation. Diese beeinflusste zahlreiche internationale Konflikte.",
};

const wann17 = {
  title: "Beginn der Kubakrise durch Entdeckung sowjetischer Raketen auf Kuba",
  caption: "Beginn Kubakrise",
  date: "16. Oktober 1962",
  description:
    "US-Aufklärungsbilder zeigten Raketenstellungen auf Kuba. Die Situation eskalierte rasch zu einer globalen Krise. Die Welt befand sich am Rand eines nuklearen Konflikts.",
};

const wann18 = {
  title:
    "Erste Landung von Christoph Kolumbus auf dem amerikanischen Kontinent",
  caption: "Kolumbus entdeckt Amerika",
  date: "12. Oktober 1492",
  description:
    "Christoph Kolumbus erreichte im Auftrag der spanischen Krone eine Insel in der Karibik. Seine Reise markierte einen Wendepunkt in der Weltgeschichte. Sie führte zu dauerhaftem Kontakt zwischen Europa und Amerika.",
};

const wann19 = {
  title:
    "Erste bekannte Ankunft eines Europäers in Nordamerika durch Leif Erikson",
  caption: "Leif Erikson erreicht Amerika",
  date: "8. Oktober 1000",
  description:
    "Der Wikinger Leif Erikson erreichte vermutlich die Küste Nordamerikas. Er gilt als erster bekannter Europäer auf dem Kontinent. Seine Reise wurde erst viel später historisch anerkannt.",
};

const wann20 = {
  title: "Erstmalige Verleihung der Academy Awards für Filme",
  caption: "Erste Oscarverleihung",
  date: "16. Mai 1929",
  description:
    "Zum ersten Mal wurden Filmpreise der Academy vergeben. Die Veranstaltung war noch klein und exklusiv. Später entwickelten sich die Oscars zu den bekanntesten Filmpreisen weltweit.",
};

const wann21 = {
  title: "Gründung des Technologieunternehmens Apple durch drei Unternehmer",
  caption: "Apple gegründet",
  date: "1. April 1976",
  description:
    "Apple wurde von Steve Jobs, Steve Wozniak und Ronald Wayne gegründet. Das Unternehmen begann mit der Entwicklung einfacher Computer. Daraus entstand später ein weltweit führender Technologiekonzern.",
};

const wann22 = {
  title: "Verabschiedung der Unabhängigkeitserklärung der Vereinigten Staaten",
  caption: "USA werden unabhängig",
  date: "4. Juli 1776",
  description:
    "Die dreizehn Kolonien erklärten ihre Loslösung von Großbritannien. Die Erklärung legte grundlegende politische Prinzipien fest. Sie gilt als zentrales Dokument der US-amerikanischen Geschichte.",
};

const wann23 = {
  title:
    "Protestaktion amerikanischer Kolonisten gegen britische Steuerpolitik",
  caption: "Boston Tea Party",
  date: "16. Dezember 1773",
  description:
    "Kolonisten warfen große Mengen Tee in den Hafen von Boston. Die Aktion richtete sich gegen britische Handelsgesetze. Sie verschärfte die Spannungen zwischen Kolonien und Krone erheblich.",
};

const wann24 = {
  title: "Zerstörung und Untergang des deutschen Schlachtschiffs Bismarck",
  caption: "Bismarck versenkt",
  date: "27. Mai 1941",
  description:
    "Die Bismarck wurde nach mehreren Gefechten im Atlantik versenkt. Das Schiff galt als eines der mächtigsten seiner Zeit. Der Untergang hatte große symbolische Bedeutung.",
};

const wann25 = {
  title:
    "Offizielle Gründung der Vereinten Nationen als internationale Organisation",
  caption: "UNO gegründet",
  date: "24. Oktober 1945",
  description:
    "Die Vereinten Nationen nahmen offiziell ihre Arbeit auf. Ziel ist die Förderung von Frieden und Zusammenarbeit. Heute gehören fast alle Staaten der Welt der Organisation an.",
};

const wann26 = {
  title: "Unterzeichnung der ersten Genfer Konvention zum Schutz Verwundeter",
  caption: "Genfer Konvention",
  date: "22. August 1864",
  description:
    "Die erste Genfer Konvention legte Regeln für den Umgang mit Verwundeten fest. Sie schuf verbindliche humanitäre Standards. Später wurde sie mehrfach erweitert und ergänzt.",
};
const wann27 = {
  title: "Inkrafttreten der Europäischen Union als politischer Staatenverbund",
  caption: "Gründung der EU",
  date: "1. November 1993",
  description:
    "Mit dem Inkrafttreten eines gemeinsamen Vertrags entstand die Europäische Union. Ziel ist die enge Zusammenarbeit europäischer Staaten. Sie beeinflusst Politik, Wirtschaft und Gesellschaft ihrer Mitglieder stark.",
};

const wann28 = {
  title: "Beginn des Sklavenaufstands unter der Führung von Spartakus",
  caption: "Spartakusaufstand",
  date: "1. September 73 v. Chr.",
  description:
    "Spartakus führte einen großen Aufstand gegen die römische Republik an. Tausende Sklaven schlossen sich ihm an. Der Aufstand stellte eine ernsthafte Bedrohung für Rom dar.",
};

const wann29 = {
  title: "Alexander wird nach dem Tod seines Vaters König von Makedonien",
  caption: "Alexander König",
  date: "20. Oktober 336 v. Chr.",
  description:
    "Alexander übernahm den Thron von Makedonien in jungen Jahren. Er erwies sich schnell als herausragender Feldherr. Sein Name wurde später weltweit bekannt.",
};

const wann30 = {
  title: "Dschingis Khan wird zum Großkhan der mongolischen Stämme ernannt",
  caption: "Dschingis Khan Herrscher",
  date: "21. März 1206",
  description:
    "Temüdschin wurde zum Anführer aller mongolischen Stämme ernannt. Er erhielt den Titel Dschingis Khan. Damit begann der Aufstieg eines riesigen Reiches.",
};

const wann31 = {
  title: "Geburt des legendären japanischen Samurai Miyamoto Musashi",
  caption: "Geburt Musashi",
  date: "12. März 1584",
  description:
    "Miyamoto Musashi wurde in Japan geboren und wurde ein berühmter Schwertkämpfer. Er nahm an zahlreichen Duellen teil. Später wurde er auch als Philosoph bekannt.",
};

const wann32 = {
  title: "Fertigstellung eines der ersten massenhaft gedruckten Bücher Europas",
  caption: "Erstes Druckbuch",
  date: "23. Februar 1455",
  description:
    "Mit dem Buchdruck begann eine neue Ära der Wissensverbreitung. Bücher konnten nun in größerer Zahl hergestellt werden. Dies veränderte Bildung und Gesellschaft nachhaltig.",
};

const wann33 = {
  title: "Erfindung des Rads als grundlegende technische Innovation",
  caption: "Erfindung des Rads",
  date: "1. Januar 3500 v. Chr.",
  description:
    "Das Rad zählt zu den wichtigsten Erfindungen der Menschheitsgeschichte. Es erleichterte Transport und Arbeit erheblich. Viele spätere Technologien bauten darauf auf.",
};

const wann34 = {
  title: "Vorstellung des ersten funktionstüchtigen Verbrennungsmotors",
  caption: "Erster Verbrennungsmotor",
  date: "24. Januar 1860",
  description:
    "Ein früher Verbrennungsmotor wurde erstmals praktisch eingesetzt. Er nutzte Gas als Brennstoff. Diese Technik ebnete den Weg für moderne Motoren.",
};

const wann35 = {
  title: "Erstes erfolgreiches Telefonat zwischen zwei Personen",
  caption: "Erstes Telefonat",
  date: "10. März 1876",
  description:
    "Über ein neu entwickeltes Gerät wurde erstmals Sprache übertragen. Das Telefon veränderte die Kommunikation grundlegend. Entfernungen spielten fortan eine geringere Rolle.",
};

const wann36 = {
  title: "Vorstellung des ersten Geräts zur Tonaufzeichnung und Wiedergabe",
  caption: "Erstes Grammophon",
  date: "6. Dezember 1877",
  description:
    "Mit dem Grammophon konnten erstmals Töne aufgezeichnet werden. Musik und Sprache wurden reproduzierbar. Dies veränderte Unterhaltung und Kultur nachhaltig.",
};

const wann37 = {
  title: "Erste erfolgreiche Übertragung einer Nachricht per Morsecode",
  caption: "Erstes Morsesignal",
  date: "24. Mai 1844",
  description:
    "Eine kurze Nachricht wurde über große Entfernung gesendet. Der Morsecode ermöglichte schnelle Kommunikation. Er wurde weltweit eingesetzt.",
};

const wann38 = {
  title: "Versand der weltweit ersten elektronischen E-Mail",
  caption: "Erste E-Mail",
  date: "3. Oktober 1971",
  description:
    "Eine Nachricht wurde erstmals über ein Computernetzwerk versendet. Dieses Prinzip prägt bis heute die digitale Kommunikation. E-Mails wurden schnell alltäglich.",
};

const wann39 = {
  title: "Beginn des Baus der großen Pyramiden von Gizeh",
  caption: "Bau Pyramiden Gizeh",
  date: "1. Januar 2580 v. Chr.",
  description:
    "In Ägypten begann der Bau monumentaler Grabstätten. Die Pyramiden wurden mit enormem Aufwand errichtet. Sie zählen zu den beeindruckendsten Bauwerken der Antike.",
};

const wann40 = {
  title:
    "Offizielle Fertigstellung des Kölner Doms nach jahrhundertelangem Bau",
  caption: "Kölner Dom fertig",
  date: "15. Oktober 1880",
  description:
    "Der Kölner Dom wurde offiziell vollendet. Der Bau hatte sich über viele Generationen erstreckt. Heute ist er eines der bekanntesten Wahrzeichen Deutschlands.",
};

const wann41 = {
  title: "Erste bemannte Landung von Menschen auf dem Mond",
  caption: "Mondlandung",
  date: "20. Juli 1969",
  description:
    "Menschen betraten erstmals die Oberfläche des Mondes. Das Ereignis wurde weltweit live verfolgt. Es gilt als Meilenstein der Raumfahrtgeschichte.",
};
const wann42 = {
  title: "Tötung des Terroristen Osama bin Laden durch eine US-Spezialeinheit",
  caption: "Osama bin Laden getötet",
  date: "2. Mai 2011",
  description:
    "Osama bin Laden wurde bei einem Militäreinsatz in Pakistan getötet. Er galt als Anführer von Al-Qaida. Der Einsatz hatte weltweit große politische Bedeutung.",
};

const wann43 = {
  title: "Schwere Terroranschläge auf Ziele in den Vereinigten Staaten",
  caption: "Terroranschlag 11. September",
  date: "11. September 2001",
  description:
    "Terroristen verübten koordinierte Anschläge mit entführten Flugzeugen. Tausende Menschen verloren dabei ihr Leben. Das Ereignis hatte tiefgreifende globale Folgen.",
};

const wann44 = {
  title: "Einführung des Euro als gemeinsame europäische Währung",
  caption: "Euro eingeführt",
  date: "1. Januar 1999",
  description:
    "Der Euro wurde als offizielle Gemeinschaftswährung eingeführt. Er erleichterte Handel und Reisen zwischen den teilnehmenden Ländern. Später wurde er auch als Bargeld genutzt.",
};

const wann45 = {
  title: "Beginn unserer heutigen Zeitrechnung",
  caption: "Beginn Zeitrechnung",
  date: "1. Januar 0",
  description:
    "Mit diesem Datum beginnt die heute gebräuchliche Zeitrechnung. Sie dient weltweit als historischer Bezugspunkt. Viele Kalender orientieren sich an diesem System.",
};

const wann46 = {
  title: "Beginn der Französischen Revolution mit dem Sturm auf die Bastille",
  caption: "Französische Revolution",
  date: "14. Juli 1789",
  description:
    "Die Bevölkerung von Paris stürmte die Bastille. Das Ereignis wurde zum Symbol des Widerstands gegen die Monarchie. Es leitete tiefgreifende gesellschaftliche Veränderungen ein.",
};

const wann47 = {
  title: "Veröffentlichung des ersten Bandes von Karl Marx Werk Das Kapital",
  caption: "Das Kapital erscheint",
  date: "14. September 1867",
  description:
    "Karl Marx veröffentlichte den ersten Band seines Hauptwerks. Das Buch analysiert wirtschaftliche und gesellschaftliche Strukturen. Es beeinflusste Politik und Ideologien weltweit.",
};

const wann48 = {
  title: "Wikinger belagern die Stadt Paris während eines großen Angriffs",
  caption: "Wikinger belagern Paris",
  date: "28. März 845",
  description:
    "Wikinger drangen tief ins Frankenreich vor und belagerten Paris. Die Stadt wurde schwer unter Druck gesetzt. Der Angriff hinterließ große Verwüstungen.",
};

const wann49 = {
  title:
    "Christentum wird zur offiziellen Staatsreligion des Römischen Reiches",
  caption: "Römer werden christlich",
  date: "27. Februar 380",
  description:
    "Das Christentum wurde offiziell zur Staatsreligion erklärt. Dies veränderte die religiöse Ausrichtung des Reiches grundlegend. Die Entscheidung prägte Europa langfristig.",
};

const wann50 = {
  title: "Veröffentlichung der 95 Thesen durch Martin Luther",
  caption: "Luthers Thesen",
  date: "31. Oktober 1517",
  description:
    "Martin Luther veröffentlichte seine 95 Thesen zur Kirchenkritik. Sie richteten sich gegen Missstände in der Kirche. Daraus entstand eine weitreichende religiöse Bewegung.",
};

const wann51 = {
  title: "Fertigstellung des Circus Maximus als größtes antikes Stadion Roms",
  caption: "Circus Maximus fertig",
  date: "1. Januar 329 v. Chr.",
  description:
    "Der Circus Maximus wurde als große Sport- und Veranstaltungsstätte genutzt. Er bot Platz für zehntausende Zuschauer. Wagenrennen gehörten zu den beliebtesten Ereignissen.",
};

const wann52 = {
  title: "Beginn des Vietnamkriegs mit militärischem Eingreifen der USA",
  caption: "Beginn Vietnamkrieg",
  date: "1. November 1955",
  description:
    "Der Konflikt in Vietnam weitete sich durch internationale Beteiligung aus. Der Krieg war lang und verlustreich. Er beeinflusste Politik und Gesellschaft stark.",
};

const wann53 = {
  title: "Kinostart des ersten Godzilla-Films in Japan",
  caption: "Erster Godzilla-Film",
  date: "3. November 1954",
  description:
    "Der Film Godzilla feierte seine Premiere in Japan. Die Figur wurde schnell weltbekannt. Sie entwickelte sich zu einer der bekanntesten Filmikonen.",
};

const wann54 = {
  title: "Erstes YouTube-Video erreicht eine Milliarde Aufrufe",
  caption: "YouTube Rekord",
  date: "21. Dezember 2012",
  description:
    "Ein Musikvideo überschritt erstmals die Marke von einer Milliarde Aufrufen. Dies zeigte die enorme Reichweite digitaler Plattformen. Onlinevideos gewannen weiter an Bedeutung.",
};

const wann55 = {
  title: "Netflix startet seinen weltweiten Streaming-Dienst",
  caption: "Netflix Streamingstart",
  date: "16. Januar 2007",
  description:
    "Netflix begann mit dem Streaming von Filmen und Serien. Das Angebot veränderte das Konsumverhalten vieler Zuschauer. Streaming wurde zu einem neuen Standard.",
};

const wann56 = {
  title: "Erstmals wird ein Film im Fernsehen ausgestrahlt",
  caption: "Erster Film im TV",
  date: "14. Juli 1930",
  description:
    "Ein Film wurde erstmals über das Fernsehen ausgestrahlt. Damit begann eine neue Form der Filmverbreitung. Fernsehen entwickelte sich zu einem wichtigen Massenmedium.",
};
const wann57 = {
  title: "Erste öffentliche Liveübertragung eines Radiosenders",
  caption: "Erster Radiosender",
  date: "2. November 1920",
  description:
    "Ein Radiosender übertrug erstmals live ein öffentliches Ereignis. Gesendet wurden Wahlergebnisse in den USA. Damit begann das Zeitalter des Rundfunks.",
};

const wann58 = {
  title:
    "Weltbevölkerung erreicht erstmals die Marke von fünf Milliarden Menschen",
  caption: "5 Milliarden Menschen",
  date: "11. Juli 1987",
  description:
    "Die Weltbevölkerung überschritt eine bedeutende Größenordnung. Dieses Wachstum zeigte globale demografische Entwicklungen deutlich. Der Tag wurde international wahrgenommen.",
};

const wann59 = {
  title: "US-Militär entführt den venezolanischen Präsidenten Nicolás Maduro",
  caption: "Maduro entführt",
  date: "3. Januar 2026",
  description:
    "US-Streitkräfte führten eine militärische Operation in Venezuela durch und nahmen Präsident Nicolás Maduro gefangen. Er wurde von den USA außer Landes gebracht und soll dort angeklagt werden. Der Einsatz löste internationale Kritik und Befürchtungen über die Rechtslage aus.", // Nachrichtenlage zeigt Kritik konnte zitiert werden
};

const wann60 = {
  title: "Erstmaliger Verkauf des Brettspiels Monopoly im großen Stil",
  caption: "Monopoly verkauft",
  date: "6. Februar 1935",
  description:
    "Das Brettspiel Monopoly wurde offiziell von einem großen Spielehersteller vermarktet. Es entwickelte sich schnell zu einem Verkaufserfolg. Bis heute zählt es zu den bekanntesten Spielen weltweit.",
};

const wann61 = {
  title: "Erster Superheldenfilm feiert Premiere im Kino",
  caption: "Erster Superheldenfilm",
  date: "5. Januar 1948",
  description:
    "Mit einem Superman-Film begann das Superhelden-Genre im Kino. Die Figur basierte auf bekannten Comics. Daraus entwickelte sich ein eigenes Filmgenre.",
};

const wann62 = {
  title: "Beginn der Opiumkrise in Asien durch massive Handelskonflikte",
  caption: "Opiumkrise beginnt",
  date: "3. Juni 1839",
  description:
    "Große Mengen Opium wurden in China beschlagnahmt und zerstört. Dies verschärfte die Spannungen mit ausländischen Handelsmächten. Der Konflikt hatte weitreichende Folgen für die Region.",
};

const wann63 = {
  title:
    "Veröffentlichung der ersten kommerziellen Spielkonsole für den Heimgebrauch",
  caption: "Erste Konsole",
  date: "1. September 1972",
  description:
    "Die erste Spielkonsole für Zuhause kam auf den Markt. Sie ermöglichte interaktive Unterhaltung im eigenen Wohnzimmer. Damit begann die Videospielindustrie.",
};

const wann64 = {
  title:
    "Beginn der industriellen Revolution mit grundlegenden wirtschaftlichen Veränderungen",
  caption: "Industrielle Revolution",
  date: "1. Januar 1760",
  description:
    "Neue Maschinen und Produktionsweisen veränderten die Arbeit grundlegend. Fabriken gewannen zunehmend an Bedeutung. Gesellschaft und Wirtschaft wandelten sich stark.",
};

const wann65 = {
  title: "Landung der alliierten Streitkräfte in der Normandie am D-Day",
  caption: "D-Day",
  date: "6. Juni 1944",
  description:
    "Alliierte Truppen landeten an den Stränden der Normandie. Die Operation war militärisch äußerst komplex. Sie gilt als entscheidender Wendepunkt im Krieg.",
};

const wann66 = {
  title: "Japanischer Angriff auf den US-Marinestützpunkt Pearl Harbor",
  caption: "Angriff auf Pearl Harbor",
  date: "7. Dezember 1941",
  description:
    "Japanische Streitkräfte griffen den Hafen von Pearl Harbor an. Zahlreiche Schiffe wurden zerstört oder beschädigt. Der Angriff hatte weitreichende politische Folgen.",
};

const wann67 = {
  title: "Erster motorisierter Flug eines Flugzeugs durch die Brüder Wright",
  caption: "Erster Motorflug",
  date: "17. Dezember 1903",
  description:
    "Die Brüder Wright führten den ersten erfolgreichen Motorflug durch. Das Flugzeug hob kontrolliert vom Boden ab. Damit begann die moderne Luftfahrt.",
};

const wann68 = {
  title: "Tod des Kaufmanns und Bankiers Jakob Fugger",
  caption: "Jakob Fugger stirbt",
  date: "30. Dezember 1525",
  description:
    "Jakob Fugger galt als einer der reichsten Menschen seiner Zeit. Sein Handels- und Finanzimperium war europaweit aktiv. Er prägte das Wirtschaftswesen nachhaltig.",
};

const wann69 = {
  title: "Erste öffentliche Fahrt einer dampfbetriebenen Eisenbahn",
  caption: "Erste Eisenbahn",
  date: "27. September 1825",
  description:
    "Eine Dampflokomotive transportierte erstmals Passagiere auf einer öffentlichen Strecke. Die Eisenbahn revolutionierte den Transport. Sie veränderte Mobilität und Handel dauerhaft.",
};

const wann70 = {
  title: "Geburt des späteren Industriellen John D Rockefeller",
  caption: "Rockefeller geboren",
  date: "8. Juli 1839",
  description:
    "John D. Rockefeller wurde geboren und wurde später ein einflussreicher Unternehmer. Er baute ein riesiges Industrieimperium auf. Sein Name ist bis heute bekannt.",
};

const wann71 = {
  title: "Reaktorkatastrophe im Kernkraftwerk Tschernobyl",
  caption: "Katastrophe Tschernobyl",
  date: "26. April 1986",
  description:
    "In einem Kernkraftwerk kam es zu einer schweren Explosion. Große Mengen radioaktiver Stoffe traten aus. Die Katastrophe hatte langfristige Folgen für Mensch und Umwelt.",
};
const wann72 = {
  title: "Schwere Reaktorkatastrophe im japanischen Kernkraftwerk Fukushima",
  caption: "Fukushima-Katastrophe",
  date: "11. März 2011",
  description:
    "Nach einem schweren Erdbeben und Tsunami kam es zu mehreren Reaktorunfällen. Große Mengen radioaktiver Stoffe traten aus. Das Ereignis führte weltweit zu Diskussionen über Atomenergie.",
};

const wann73 = {
  title: "Beginn des sagenhaften Trojanischen Krieges um die Stadt Troja",
  caption: "Trojanischer Krieg",
  date: "1. Mai 1194 v. Chr.",
  description:
    "Der Krieg zwischen Griechen und Trojanern ist vor allem aus antiken Epen bekannt. Er drehte sich um die belagerte Stadt Troja. Historische und mythische Elemente sind eng miteinander verbunden.",
};

const wann74 = {
  title:
    "Gründung der Weltgesundheitsorganisation als internationale Institution",
  caption: "WHO gegründet",
  date: "7. April 1948",
  description:
    "Die World Health Organization nahm offiziell ihre Arbeit auf. Sie koordiniert internationale Gesundheitsfragen. Ihr Ziel ist die Verbesserung der globalen Gesundheitsversorgung.",
};

const wann75 = {
  title: "Erprobung des ersten funktionsfähigen Dampfwagens",
  caption: "Erster Dampfwagen",
  date: "23. Oktober 1769",
  description:
    "Ein selbstfahrendes Fahrzeug mit Dampfantrieb wurde erstmals getestet. Es konnte schwere Lasten bewegen. Damit begann die Entwicklung motorisierter Fahrzeuge.",
};

const wann76 = {
  title:
    "Proklamation des Deutschen Kaiserreichs im Spiegelsaal von Versailles",
  caption: "Deutsches Kaiserreich",
  date: "18. Januar 1871",
  description:
    "Ein deutscher Nationalstaat wurde offiziell ausgerufen. Der preußische König wurde Kaiser. Das Ereignis veränderte die politische Ordnung Europas nachhaltig.",
};

const wann77 = {
  title: "Ausrufung der Weimarer Republik nach dem Ende der Monarchie",
  caption: "Weimarer Republik",
  date: "9. November 1918",
  description:
    "In Deutschland wurde eine neue Staatsform verkündet. Die Monarchie wurde beendet. Dies markierte den Beginn einer demokratischen Phase.",
};

const wann78 = {
  title: "Isaac Newton veröffentlicht seine Theorie der Gravitation",
  caption: "Gravitation entdeckt",
  date: "5. Juli 1687",
  description:
    "Isaac Newton stellte seine Gesetze der Bewegung und Gravitation vor. Sie erklärten die Bewegung von Himmelskörpern und Objekten auf der Erde. Seine Arbeit prägte die Physik über Jahrhunderte.",
};

const wann79 = {
  title: "Albert Einstein formuliert die Allgemeine Relativitätstheorie",
  caption: "Relativitätstheorie",
  date: "25. November 1915",
  description:
    "Albert Einstein präsentierte eine neue Beschreibung von Raum und Zeit. Gravitation wurde als Krümmung der Raumzeit erklärt. Die Theorie veränderte das Verständnis des Universums grundlegend.",
};

const wann80 = {
  title: "Erfindung des Schießpulvers als revolutionäre chemische Mischung",
  caption: "Schießpulver erfunden",
  date: "1. Januar 850",
  description:
    "In China wurde eine explosive Mischung entdeckt. Sie wurde zunächst für Feuerwerke genutzt. Später veränderte sie die Kriegsführung weltweit.",
};

const wann81 = {
  title: "Patentierung des ersten modernen Revolvers",
  caption: "Erster Revolver",
  date: "25. Februar 1836",
  description:
    "Ein mehrschüssiger Handfeuerwaffentyp wurde patentiert. Er erlaubte schnelles wiederholtes Schießen. Dies beeinflusste Waffenentwicklung nachhaltig.",
};

const wann82 = {
  title: "Vorstellung des ersten praktikablen Fotoapparats",
  caption: "Erster Fotoapparat",
  date: "7. Januar 1839",
  description:
    "Ein Verfahren zur dauerhaften Bildaufnahme wurde öffentlich vorgestellt. Fotografien konnten nun festgehalten werden. Dies veränderte Kunst und Dokumentation grundlegend.",
};

const wann83 = {
  title: "Vincent van Gogh malt das Gemälde Sternennacht",
  caption: "Sternennacht gemalt",
  date: "18. Juni 1889",
  description:
    "Vincent van Gogh schuf eines seiner bekanntesten Werke. Das Bild zeigt einen nächtlichen Himmel in ausdrucksstarkem Stil. Es zählt heute zu den berühmtesten Gemälden der Welt.",
};

const wann84 = {
  title: "Geburt des Universalgenies Leonardo da Vinci",
  caption: "Da Vinci geboren",
  date: "15. April 1452",
  description:
    "Leonardo da Vinci wurde in Italien geboren. Er wirkte als Künstler, Ingenieur und Wissenschaftler. Sein Werk beeinflusst Kunst und Forschung bis heute.",
};

const wann85 = {
  title:
    "Veröffentlichung des heliozentrischen Weltbildes durch Nikolaus Kopernikus",
  caption: "Kopernikus Weltbild",
  date: "24. Mai 1543",
  description:
    "Nikolaus Kopernikus stellte die Sonne ins Zentrum des Planetensystems. Diese Idee widersprach dem damaligen Weltbild. Sie leitete einen wissenschaftlichen Umbruch ein.",
};

const wann86 = {
  title:
    "Galileo Galilei veröffentlicht bahnbrechende astronomische Beobachtungen",
  caption: "Galileo Astronomie",
  date: "13. März 1610",
  description:
    "Galileo veröffentlichte Beobachtungen mit einem Teleskop. Er entdeckte unter anderem Jupitermonde. Seine Arbeit unterstützte das heliozentrische Weltbild.",
};
const wann87 = {
  title: "Gründung der Walt Disney Company als neues Unterhaltungsstudio",
  caption: "Disney gegründet",
  date: "16. Oktober 1923",
  description:
    "Walt Disney gründete gemeinsam mit seinem Bruder ein Animationsstudio. Anfangs entstanden kurze Zeichentrickfilme. Daraus entwickelte sich eines der größten Medienunternehmen der Welt.",
};

const wann88 = {
  title: "Erstmaliger Verkauf des Getränks Coca Cola",
  caption: "Coca Cola erscheint",
  date: "8. Mai 1886",
  description:
    "Coca Cola wurde erstmals in einer Apotheke verkauft. Das Getränk war zunächst als Sirup gedacht. Später entwickelte es sich zu einer weltbekannten Marke.",
};

const wann89 = {
  title: "Entstehung der ersten modernen Börse in Amsterdam",
  caption: "Erste Börse",
  date: "1. Januar 1602",
  description:
    "In Amsterdam entstand eine organisierte Handelsbörse. Aktien konnten dort öffentlich gehandelt werden. Dieses System prägte den modernen Finanzmarkt.",
};

const wann90 = {
  title: "Bau der ersten industriellen Ölbohrinsel",
  caption: "Erste Bohrinsel",
  date: "26. August 1896",
  description:
    "Vor der Küste Kaliforniens wurde eine Ölbohrinsel errichtet. Öl konnte erstmals direkt vom Meer aus gefördert werden. Dies veränderte die Energiegewinnung nachhaltig.",
};

const wann91 = {
  title: "Amazon geht erstmals als Onlineplattform live",
  caption: "Amazon startet",
  date: "16. Juli 1995",
  description:
    "Amazon startete als Onlinebuchhandlung im Internet. Kunden konnten Bücher digital bestellen. Daraus entstand später ein globaler Handelskonzern.",
};

const wann92 = {
  title: "Ernennung der ersten Frau zur deutschen Bundeskanzlerin",
  caption: "Erste Bundeskanzlerin",
  date: "22. November 2005",
  description:
    "Angela Merkel wurde zur Bundeskanzlerin gewählt. Sie war die erste Frau in diesem Amt. Ihre Amtszeit prägte die deutsche Politik stark.",
};

const wann93 = {
  title: "Gründung der Europäischen Weltraumorganisation ESA",
  caption: "ESA gegründet",
  date: "30. Mai 1975",
  description:
    "Mehrere europäische Staaten gründeten eine gemeinsame Raumfahrtorganisation. Ziel ist die Zusammenarbeit in der Raumfahrt. Die ESA betreibt zahlreiche Missionen.",
};

const wann94 = {
  title: "Durchführung der ersten Google Suchanfrage",
  caption: "Erste Google Suche",
  date: "27. September 1998",
  description:
    "Die Suchmaschine Google wurde erstmals öffentlich genutzt. Nutzer konnten Webseiten effizient durchsuchen. Google veränderte den Zugang zu Informationen grundlegend.",
};

const wann95 = {
  title: "Adolf Hitler wird zum Reichskanzler ernannt",
  caption: "Hitler an der Macht",
  date: "30. Januar 1933",
  description:
    "Adolf Hitler wurde zum deutschen Reichskanzler ernannt. Damit begann eine neue politische Phase in Deutschland. Die Folgen waren weitreichend und gravierend.",
};

const wann96 = {
  title: "Russland annektiert die ukrainische Halbinsel Krim",
  caption: "Krim annektiert",
  date: "18. März 2014",
  description:
    "Russland erklärte die Eingliederung der Krim in sein Staatsgebiet. Die Aktion wurde international stark kritisiert. Sie führte zu politischen Spannungen.",
};

const wann97 = {
  title: "Erster erfolgreicher Flug des Überschallflugzeugs Concorde",
  caption: "Erster Concorde Flug",
  date: "2. März 1969",
  description:
    "Die Concorde absolvierte ihren Jungfernflug. Das Flugzeug konnte schneller als der Schall fliegen. Es galt als technisches Prestigeprojekt.",
};

const wann98 = {
  title: "Erster erfolgreicher Flug eines Zeppelins",
  caption: "Erster Zeppelin",
  date: "2. Juli 1900",
  description:
    "Ein Starrluftschiff absolvierte seinen ersten kontrollierten Flug. Zeppeline wurden später für Transport und Beobachtung genutzt. Sie prägten die frühe Luftfahrt.",
};

const wann99 = {
  title: "Indienststellung des ersten echten Flugzeugträgers",
  caption: "Erster Flugzeugträger",
  date: "16. September 1918",
  description:
    "Ein Schiff wurde speziell für den Einsatz von Flugzeugen gebaut. Start und Landung erfolgten direkt an Bord. Dies veränderte die Seekriegsführung grundlegend.",
};

const wann100 = {
  title: "Erster Kampfeinsatz eines Panzers auf dem Schlachtfeld",
  caption: "Erster Panzer",
  date: "15. September 1916",
  description:
    "Panzerfahrzeuge wurden erstmals im Krieg eingesetzt. Sie konnten Gräben und Hindernisse überwinden. Damit begann eine neue Form der Kriegsführung.",
};

const wann101 = {
  title: "Gründung des Königreichs Preußen",
  caption: "Preußen gegründet",
  date: "18. Januar 1701",
  description:
    "Das Königreich Preußen wurde offiziell ausgerufen. Der Herrscher erhielt den Königstitel. Preußen entwickelte sich zu einer bedeutenden Macht in Europa.",
};
const wann102 = {
  title: "Sprung aus der Stratosphäre von Felix Baumgartner als Weltrekord",
  caption: "Baumgartner Sprung",
  date: "14. Oktober 2012",
  description:
    "Felix Baumgartner sprang aus über 39 Kilometern Höhe. Er durchbrach dabei die Schallgeschwindigkeit im freien Fall. Das Ereignis war weltweit live im Fernsehen zu sehen.",
};

const wann103 = {
  title:
    "Erfindung der ersten tragbaren Taschenuhr für den persönlichen Gebrauch",
  caption: "Erste Taschenuhr",
  date: "16. Dezember 1510",
  description:
    "Die erste Taschenuhr ermöglichte es, die Zeit jederzeit bei sich zu tragen. Sie war mechanisch betrieben. Die Uhr beeinflusste Mode und Alltag erheblich.",
};

const wann104 = {
  title:
    "Rosa Parks verweigert den Sitzplatz in einem Bus und löst Bürgerrechtsbewegung aus",
  caption: "Rosa Parks",
  date: "1. Dezember 1955",
  description:
    "Rosa Parks setzte sich im Bus gegen Diskriminierung zur Wehr. Ihr Handeln führte zu Protesten und Streiks. Sie wurde zu einem Symbol der Bürgerrechtsbewegung in den USA.",
};

const wann105 = {
  title:
    "Florence Nightingale revolutioniert die Krankenpflege und das Hygieneverständnis",
  caption: "Nightingale Pflege",
  date: "12. März 1854",
  description:
    "Florence Nightingale führte moderne Standards in Krankenhäusern ein. Sie legte großen Wert auf Hygiene und Organisation. Ihr Einfluss prägt die Pflege bis heute.",
};

const wann106 = {
  title:
    "Einbau der ersten Fensterscheiben in Häuser zur Beleuchtung und Isolation",
  caption: "Erstes Fenster",
  date: "2. Januar 1000",
  description:
    "Die ersten Fensterscheiben wurden genutzt, um Licht hereinzulassen. Gleichzeitig boten sie Schutz vor Witterung. Fenster veränderten die Bauweise von Häusern nachhaltig.",
};

const wann107 = {
  title: "Erfolgreicher Start des ersten bemannten Heißluftballons",
  caption: "Erster Heißluftballon",
  date: "21. November 1783",
  description:
    "Die Brüder Montgolfier ließen einen Heißluftballon steigen. Er transportierte Passagiere sicher durch die Luft. Dies war der Beginn der bemannten Luftfahrt.",
};

const wann108 = {
  title: "Erfindung des ersten funktionsfähigen Microcontrollers",
  caption: "Erster Microcontroller",
  date: "15. November 1971",
  description:
    "Der erste Microcontroller integrierte Prozessor, Speicher und Peripherie auf einem Chip. Er ermöglichte neue Technologien in Elektronik und Industrie. Der Chip legte den Grundstein für moderne Geräte.",
};

const wann109 = {
  title: "Abschaffung der Sklaverei in den Vereinigten Staaten",
  caption: "Sklaverei abgeschafft",
  date: "6. Dezember 1865",
  description:
    "Die Sklaverei wurde offiziell beendet. Millionen Menschen gewannen ihre Freiheit. Das Ereignis markierte einen wichtigen Schritt zur Gleichberechtigung.",
};

const wann110 = {
  title: "Vorstellung des ersten kommerziellen Mobiltelefons",
  caption: "Erstes Mobiltelefon",
  date: "3. April 1973",
  description:
    "Martin Cooper präsentierte das erste funktionsfähige Mobiltelefon. Es ermöglichte mobile Telefonate ohne Kabel. Damit begann die Ära der mobilen Kommunikation.",
};

const wann111 = {
  title: "Entdeckung der Röntgenstrahlen durch Wilhelm Conrad Röntgen",
  caption: "Erstes Röntgengerät",
  date: "8. November 1895",
  description:
    "Röntgen entdeckte Strahlen, die den menschlichen Körper durchdringen konnten. Er baute das erste Röntgengerät. Die Methode revolutionierte die Medizin.",
};

const wann112 = {
  title: "Bau und erster Einsatz eines U-Boots",
  caption: "Erstes U-Boot",
  date: "17. Juli 1620",
  description:
    "Ein unter Wasser fahrendes Gefährt wurde erfolgreich getestet. Es konnte taktisch eingesetzt werden. Die Erfindung legte den Grundstein für die Unterwasserfahrt.",
};

const wann113 = {
  title: "Markteinführung des ersten modernen Kühlschranks für Haushalte",
  caption: "Erster Kühlschrank",
  date: "6. Dezember 1913",
  description:
    "Der Kühlschrank ermöglichte die sichere Lagerung von Lebensmitteln. Er nutzte mechanische Kühlung. Dies veränderte Haushalte und Ernährung nachhaltig.",
};

const wann114 = {
  title:
    "Sokrates unterrichtet Philosophie in Athen und prägt Schüler wie Platon",
  caption: "Sokrates unterrichtet",
  date: "1. Januar 400 v. Chr.",
  description:
    "Sokrates lehrte in der Öffentlichkeit durch Dialog und Fragen. Er beeinflusste Schüler wie Platon. Seine Methoden prägten die westliche Philosophie grundlegend.",
};

const wann115 = {
  title:
    "Gründung der World Trade Organization als internationale Handelsorganisation",
  caption: "WTO gegründet",
  date: "1. Januar 1995",
  description:
    "Die WTO übernahm Aufgaben zur Regelung des internationalen Handels. Sie fördert offene Märkte und Schlichtung von Handelsstreitigkeiten. Ihr Einfluss ist global spürbar.",
};

const wann116 = {
  title: "Gründung der Gruppe der 20 führenden Industrie- und Schwellenländer",
  caption: "G20 gegründet",
  date: "26. September 1999",
  description:
    "Die G20 wurde zur Koordination globaler Wirtschaftspolitik gegründet. Sie umfasst Industrie- und Schwellenländer. Die Gruppe trifft Entscheidungen zu Finanz- und Wirtschaftsthemen.",
};

const wann117 = {
  title: "Weltbevölkerung erreicht erstmals acht Milliarden Menschen",
  caption: "8 Milliarden Menschen",
  date: "15. November 2022",
  description:
    "Die Menschheit überschritt die Marke von acht Milliarden. Dies zeigt das anhaltende Bevölkerungswachstum. Ereignisse wie diese werden global beachtet.",
};
const wann118 = {
  title: "Ausbruch des Vesuvs und Zerstörung der Stadt Pompeji",
  caption: "Vesuv-Ausbruch",
  date: "24. August 79",
  description:
    "Der Vulkan Vesuv brach aus und begrub Pompeji unter Asche. Zahlreiche Menschen starben. Das Ereignis hinterließ eine der am besten dokumentierten antiken Katastrophen.",
};

const wann119 = {
  title: "Fall von Konstantinopel und Ende des Byzantinischen Reiches",
  caption: "Konstantinopel fällt",
  date: "29. Mai 1453",
  description:
    "Osmanische Truppen eroberten die Stadt Konstantinopel. Damit endete das Byzantinische Reich. Das Ereignis veränderte die politische und religiöse Landkarte Europas.",
};

const wann120 = {
  title: "Barrikadenkämpfe während der Märzrevolution in Berlin",
  caption: "Barrikaden Berlin",
  date: "18. März 1848",
  description:
    "Bürger errichteten Barrikaden gegen die preußische Armee. Die Kämpfe waren Teil der gesamtdeutschen Märzrevolution. Sie führten zu politischen Reformen in Preußen.",
};

const wann121 = {
  title: "Beginn des Baus der Berliner Mauer zur Teilung der Stadt",
  caption: "Mauerbau Berlin",
  date: "13. August 1961",
  description:
    "Die DDR begann, eine Mauer durch Berlin zu errichten. Sie trennte Familien und Freunde. Die Mauer wurde zum Symbol des Kalten Krieges.",
};

const wann122 = {
  title:
    "Deutsche Wiedervereinigung nach der Teilung in Ost- und Westdeutschland",
  caption: "Wiedervereinigung",
  date: "3. Oktober 1990",
  description:
    "Ost- und Westdeutschland wurden offiziell wieder vereint. Die Mauer war kurz zuvor gefallen. Die Wiedervereinigung markierte einen historischen Wendepunkt.",
};

const wann123 = {
  title: "Offizielle Auflösung der Sowjetunion und Ende des Kalten Krieges",
  caption: "Sowjetunion endet",
  date: "26. Dezember 1991",
  description:
    "Die Sowjetunion wurde formell aufgelöst. Ihre Mitgliedsstaaten wurden unabhängig. Dies beendete eine Ära geopolitischer Spannungen.",
};

const wann124 = {
  title: "Durchführung der ersten modernen Olympischen Spiele in Athen",
  caption: "Erste Olympische Spiele",
  date: "6. April 1896",
  description:
    "Die Spiele fanden in Athen statt. Athleten aus mehreren Nationen nahmen teil. Sie begründeten die Tradition der modernen Olympischen Spiele.",
};

const wann125 = {
  title: "Schlacht bei Actium zwischen Octavian und Marcus Antonius",
  caption: "Schlacht bei Actium",
  date: "2. September 31 v. Chr.",
  description:
    "Octavian besiegte Marcus Antonius und Kleopatra. Die Schlacht markierte das Ende des Römischen Bürgerkriegs. Octavian wurde später Kaiser Augustus.",
};

const wann126 = {
  title: "Vasco da Gama erreicht Indien auf dem Seeweg um Afrika",
  caption: "Da Gama in Indien",
  date: "20. Mai 1498",
  description:
    "Vasco da Gama segelte erfolgreich von Portugal nach Indien. Dies eröffnete den Seehandel zwischen Europa und Asien. Die Entdeckung hatte weitreichende wirtschaftliche Folgen.",
};

const wann127 = {
  title: "Ferdinand Magellan umsegelt als erster die Erde",
  caption: "Magellan Weltumsegelung",
  date: "6. September 1519",
  description:
    "Magellan startete die erste Expedition, die die Erde umrundete. Er bewies, dass die Welt rund ist und vollständig befahrbar. Die Reise war historisch bedeutsam.",
};

const wann128 = {
  title: "Erste Entdeckung eines Asteroiden durch Giuseppe Piazzi",
  caption: "Ceres entdeckt",
  date: "1. Januar 1801",
  description:
    "Piazzi entdeckte das erste bekannte Objekt im Asteroidengürtel, Ceres. Dies war der Beginn der modernen Asteroidenforschung. Ceres ist heute als Zwergplanet klassifiziert.",
};

const wann129 = {
  title: "Entdeckung des Penicillins durch Alexander Fleming",
  caption: "Penicillin entdeckt",
  date: "28. September 1928",
  description:
    "Fleming entdeckte eine Substanz, die Bakterien abtötet. Diese Entdeckung führte zur Entwicklung von Antibiotika. Sie rettete Millionen von Menschenleben.",
};

const wann130 = {
  title:
    "Schwarzer Montag: schwerer Börsencrash an den internationalen Finanzmärkten",
  caption: "Schwarzer Montag",
  date: "19. Oktober 1987",
  description:
    "Die Börsen weltweit stürzten stark ab. Viele Investoren verloren erhebliche Vermögen. Der Tag bleibt als einer der größten Finanzcrashs der Geschichte in Erinnerung.",
};

const wann131 = {
  title: "Start von Sputnik 1, dem ersten künstlichen Satelliten der Erde",
  caption: "Sputnik 1 startet",
  date: "4. Oktober 1957",
  description:
    "Die Sowjetunion startete den ersten Satelliten in die Erdumlaufbahn. Dies markierte den Beginn des Weltraumzeitalters. Sputnik löste internationalen Wettlauf ins All aus.",
};

const wann132 = {
  title: "Ermordung des Musikers John Lennon in New York",
  caption: "John Lennon ermordet",
  date: "8. Dezember 1980",
  description:
    "John Lennon wurde vor seinem Wohnhaus erschossen. Sein Tod erschütterte Fans weltweit. Lennon gilt bis heute als Symbol für Frieden und Musik.",
};

const wann133 = {
  title: "Freilassung von Nelson Mandela nach jahrzehntelanger Inhaftierung",
  caption: "Mandela freigelassen",
  date: "11. Februar 1990",
  description:
    "Nelson Mandela wurde aus dem Gefängnis entlassen. Er hatte gegen das Apartheidregime in Südafrika gekämpft. Seine Freilassung markierte einen Wendepunkt für die Demokratie.",
};

const wann134 = {
  title:
    "Offizieller Austritt des Vereinigten Königreichs aus der Europäischen Union",
  caption: "Brexit",
  date: "31. Januar 2020",
  description:
    "Das Vereinigte Königreich verließ formal die EU. Dies folgte auf ein Referendum von 2016. Der Brexit veränderte die politische und wirtschaftliche Lage in Europa.",
};

export const WannWarEsData = [
  wann1,
  wann2,
  wann3,
  wann4,
  wann5,
  wann6,
  wann7,
  wann8,
  wann9,
  wann10,
  wann11,
  wann12,
  wann13,
  wann14,
  wann15,
  wann16,
  wann17,
  wann18,
  wann19,
  wann20,
  wann21,
  wann22,
  wann23,
  wann24,
  wann25,
  wann26,
  wann27,
  wann28,
  wann29,
  wann30,
  wann31,
  wann32,
  wann33,
  wann34,
  wann35,
  wann36,
  wann37,
  wann38,
  wann39,
  wann40,
  wann41,
  wann42,
  wann43,
  wann44,
  wann45,
  wann46,
  wann47,
  wann48,
  wann49,
  wann50,
  wann51,
  wann52,
  wann53,
  wann54,
  wann55,
  wann56,
  wann57,
  wann58,
  wann59,
  wann60,
  wann61,
  wann62,
  wann63,
  wann64,
  wann65,
  wann66,
  wann67,
  wann68,
  wann69,
  wann70,
  wann71,
  wann72,
  wann73,
  wann74,
  wann75,
  wann76,
  wann77,
  wann78,
  wann79,
  wann80,
  wann81,
  wann82,
  wann83,
  wann84,
  wann85,
  wann86,
  wann87,
  wann88,
  wann89,
  wann90,
  wann91,
  wann92,
  wann93,
  wann94,
  wann95,
  wann96,
  wann97,
  wann98,
  wann99,
  wann100,
  wann101,
  wann102,
  wann103,
  wann104,
  wann105,
  wann106,
  wann107,
  wann108,
  wann109,
  wann110,
  wann111,
  wann112,
  wann113,
  wann114,
  wann115,
  wann116,
  wann117,
  wann118,
  wann119,
  wann120,
  wann121,
  wann122,
  wann123,
  wann124,
  wann125,
  wann126,
  wann127,
  wann128,
  wann129,
  wann130,
  wann131,
  wann132,
  wann133,
  wann134,
];
